// extracted by mini-css-extract-plugin
export default {"pushBlock":"Push_pushBlock__FFCag","pushGeneral":"Push_pushGeneral__XCTeE","pushContent":"Push_pushContent__iT-up"};